type StateType = {
  locked: boolean;
  dirty: boolean;
  shouldFocus: boolean;
  originalValue: string | null;
};

export const initialLockedTextState: StateType = {
  locked: false,
  dirty: false,
  shouldFocus: false,
  originalValue: null,
};

type ActionType =
  | {
      variant: 'reset';
    }
  | {
      variant: 'onInitialChange';
    }
  | {
      variant: 'onFocus';
      originalValue: string;
    }
  | {
      variant: 'setShouldFocus';
      value: boolean;
    }
  | {
      variant: 'onBlur';
    }
  | {
      variant: 'onEditClick';
    }
  | {
      variant: 'setLocked';
      value: boolean;
    };

export const lockedTextReducer = (state: StateType, action: ActionType) => {
  let newState: StateType = state;
  switch (action.variant) {
    case 'reset':
      break;
    case 'onFocus':
      newState = {
        ...state,
        originalValue: action.originalValue,
      };
      break;
    case 'setShouldFocus':
      newState = {
        ...state,
        shouldFocus: action.value,
      };
      break;
    case 'onInitialChange':
      newState = {
        ...state,
        dirty: true,
      };
      break;
    case 'onBlur':
      newState = {
        ...state,
        locked: false,
        dirty: false,
      };
      break;
    case 'onEditClick':
      newState = {
        ...state,
        locked: true,
        shouldFocus: true,
      };
      break;
    case 'setLocked':
      newState = {
        ...state,
        locked: action.value,
      };
      break;
  }

  return newState;
};
